export default {
  lang: 'English',
  homeScreen: {
    title: 'HomeTitle', // Product specific
    stayConnected: 'Stay Connected',
    comingSoon: 'Coming Soon',
    download: 'Download the app',
    storeButtons: {
      getApp: 'Get the app on your mobile device',
    },
    header: {
      blogs: 'Blogs:',
    },
  },
  loginScreen: {
    title: 'Travel Professional Training and Sales Enablement Program', // Product specific (TravPRO text or ChannelPRO text)
    welcome: {
      headerTop: 'Welcome to the',
      headerBottom: 'Future of Tourism Toolkit', // Product specific
    },
    sellingPoints: {
      // All selling points can be product specific
      0: 'Certificate of Completion',
      1: 'Expert Designation',
      2: 'Exclusive Expert Logo',
      3: 'Free, High-Quality Marketing Materials',
      4: 'Access to Booking Incentives and Special Offers/Promotions',
    },
    emailPrompt: 'Login with your email to continue:', // Product specific (TravPRO or ChannelPRO text)
    tAndC: {
      agree: 'By continuing you agree with our ',
      privacyPolicy: 'privacy policy',
      and: ' and ',
      termsConditions: 'terms and conditions',
    },
    fields: {
      agency: 'Agency',
      email: 'Email',
      password: 'Password',
      passwordConfirm: 'Confirm Password',
      firstName: 'First name',
      lastName: 'Last name',
      agencyName: 'Business',
      stateProvince: 'State / Province',
      required: 'Required',
      invalidEmail: 'Invalid email address',
      optInMarketing: 'Opt in to marketing emails',
      opt: "Stay In Touch! Yes, I'd like to opt in to communications from Product that will keep me posted on news, events, incentives, FAM’s and more!", // Product specific
    },
    noAgent: {
      noAgentButton: "I'm not an agent",
      title: 'Thank you for your interest in Future of Tourism Toolkit.', // Product specific
      messageWeb:
        'The content on this site is exclusively for travel professionals. To learn more about Future of Tourism Toolkit, please visit: ', // Product specific
      messageMobile:
        "Some content on this app is exclusively for travel professionals, but feel free to browse a preview of what this app has to offer by pressing 'Continue'.", // Product specific
      continue: 'Continue',
      visitWebsite: 'Visit website',
    },
    newUser: 'New User',
    register: 'Register',
  },
  welcomeScreen: {
    title: 'Welcome to the\nProduct Training Program and Sales Companion', // Product specific
    helloUser: 'Hello {name}',
    hello: 'Hello,',
    fromAgency: 'from {agency}',
    notUser: 'Not {name}?',
    introOnline: "Train immediately online or preload the content so it's always available for offline use!",
    introOffline: 'You already have the latest version preloaded. Start training or selling anytime, anywhere!',
    startTraining: 'Start training',
    downloader: {
      preload: 'Preload',
      stop: 'stop',
      init: 'Initializing...',
      lastUpdate: 'Last update: ',
    },
  },
  trainingScreens: {
    review: 'Review',
    start: 'Start',
    continue: 'Continue',
    comingSoon: 'Coming soon: {title}',
    completed: 'Completed',
    restart: 'Restart',
    tip: 'You earn your status by completing<br />the modules within each tier. <br />Dream big and reach Gold CA STAR status<br />by completing all modules!',
    essential: 'Essential Modules',
    essentialSub: 'Finish these modules to Earn Your Bronze CA STAR Status',
    specialization: 'Specialization Modules',
    specializationSub: 'Finish these modules to Achieve Your Silver CA STAR Status',
    subApps: 'Partner Modules',
    subAppsSub: 'Finish these modules to Achieve Your Gold CA STAR Status',
    status: 'Current Status:',
    durationInMinutes: '{number} minutes',
    percentageComplete: '{number}% Complete',
    unlock: 'Unlock this chapter by completing training chapter {number}.',
    unlockSubtitle: 'Unlock more chapters by completing training chapters.',
    allUnlocked: 'You have unlocked all chapters!',
    certificate: 'Certificate',
    courseComplete: 'Course complete!',
    endReached: "You've reached the end",
    retainEnd: 'Use the top bar to navigate around in this chapter or press the back button to return to the overview.',
    watchListenRead: 'Watch, Listen & Read more',
    trouble: "It looks like you're having trouble, would you like to skip this question?",
    incorrect: "Sorry! That's incorrect.",
    mistake: 'mistake',
    mistakes: 'mistakes',
    tooManyMistakes: "You've made 3 mistakes. We recommend you visit the training section for more training.",
    confirm: 'Confirm your answer',
    choose: 'Please choose an answer',
    skip: 'Skip question',
    next: 'Next question',
    retry: 'Try Again',
    fastTrackText: {
      success: "Congratulations, you've passed the Fast Track course and unlocked the rest of the training!",
      failed: "Unfortunately you didn't pass the Fast Track course, you can resume your training to earn your diploma!",
    },
    fastTrack: 'Would you like to enter the Fast Track course?',
    fastTrackExplanation:
      'Are you a {appName} expert already? The Fast Track is a condensed course to test your knowledge. Passing this course will let you bypass the regular training.',
    fastTrackButton: 'Fast Track',
    grading: 'Your final grade is a{n} {grade}',
  },
  nav: {
    home: 'Home',
    discover: 'Discover',
    reference: 'Reference',
    tools: 'Tools',
    services: 'Services',
    train: 'Train',
    retain: 'Retain',
    directory: 'Directory',
    promote: 'Promote',
    sell: 'Sell',
    info: 'Info',
    media: 'Media',
    favorites: 'Favorites',
    contact: 'Contact',
    reportCard: 'View Diploma',
    accountSettings: 'Account Settings',
    messages: 'Messages',
    search: 'Search',
  },
  contentHeaders: {
    train: 'Discover',
    retain: 'Retain',
    subapps: 'Partner Specialist Programs',
    maintrainings: 'Essential Modules',
    subtrainings: 'Specialization Modules',
  },
  sharing: {
    copyURL: 'Copy link',
    copied: 'Copied!',
  },
  pageDescriptions: {
    train: 'Educate, Engage and Become the Expert.',
    retain:
      'Your go-to resource for retaining your expert knowledge and enabling your sales efforts. Use this area to expertly answer a product question or even as an impromptu sales presentation — anytime, anywhere and from any device.',
    promote: 'White papers, research, and other materials to help educate and inform your sustainability journey.',
    sell: 'Equip yourself with best practices, action plans, and other tools to use your business as a force for good.',
    services: 'Programs and initiatives you can participate in to action your sustainability plans.',
    favorites: 'Check out your personally favorited content',
    search: 'Look through all content',
    subapps: 'Learn more from our partners',
    maintrainings: 'Complete these modules to learn the basics for selling',
    subtrainings: 'Learn about the specific products',
  },
  general: {
    next: 'Next',
    previous: 'Previous',
    submit: 'Submit',
    back: 'Back',
    close: 'Close',
    yes: 'Yes',
    no: 'No',
    page: 'Page',
    search: 'Search',
    noAgentButton: "I'm not an agent",
    logIn: 'Log in',
    logOut: 'Log Out',
    viewItem: 'View {type}',
    imageNotFound: 'Image not found',
    noResultsFor: 'No results have been found for: {{query}}',
    noFavorites: "You don't have any favorites yet.",
    noMessages: "You haven't received any messages yet!",
    resultsFor: 'Results for: {query}',
    showAll: 'Show all',
    connectionError: 'Connection error',
    alreadyExists: 'Already exists',
    pageNotFound: '404 Page Not Found!',
    oops: 'Uh oh...',
    overview: 'Return to overview',
    courseComplete: 'Course Complete!',
    chapterComplete: 'Chapter Complete!',
    message: '{count} Message',
    messagePlural: '{count} Messages',
  },
  messageCenter: {
    dayAgo: '1 day ago',
    monthAgo: '1 month ago',
    yearAgo: '1 year ago',
  },
  itemTypes: {
    image: 'Image',
    brochure: 'Collection',
    layout: 'Layout',
    web: 'Website',
    pdf: 'PDF',
    carousel: 'Collection',
  },
  collectionView: {
    main: 'Home',
    sell: 'Sell',
    promote: 'Promote',
  },
  questions: {
    dials: 'Rotate the dials to match the answer',
    fitb: 'Fill in the blank(s)',
    flip: 'Change the number to match the answer',
    multipleChoice: 'Pick the right answer(s)',
    slider: 'Pick the right answer using the slider',
    map: 'Answer the question by tapping the right location on the map',
    dropdown: 'Choose...',
    true: 'True',
    false: 'False',
  },
  reportCard: {
    download: 'Download',
    email: 'Email',
    print: 'Print',
    confirm: 'Close',
  },
  cookies: {
    consent: 'AGREE',
    optout: 'Opt-out',
    settings: 'Privacy Settings',
    message:
      "You haven't told us anything about your data privacy preferences! That's ok, but we'd like to offer you the best experience using the Sales Companion.",
    disabled: 'It looks like you have disabled the use of cookies.',
    use: 'The {{appName}} requires the use of cookies to deliver you the best experience.',
    details: 'What are the cookies used for?',
    enable: 'See how to enable your cookies {{here}}.',
    here: 'here',
  },
  notLoggedIn: {
    super: "You're not logged in",
    title: 'You need to be logged in to view this content',
    guest: 'Guest',
  },
  demo: {
    message: 'This website is a demo of the final product. It is currently in-development and not a complete product.',
    consent: 'Understood!',
  },
  share: {
    header: 'Share this resource:',
    download: 'download',
  },
  errors: {
    comingSoon: 'Coming soon...',
    missingContent: 'The requested content is still in production.',
  },
  breadCrumbs: {
    page: 'Page',
  },
  onMobile: {
    header: "It looks like you're trying to access the {appName} app from a mobile device",
    body: 'To download this program simply visit your app store and search for {appName} or click one of the buttons below',
    benefits: {
      header: 'This will provide you with:',
      1: 'Portability',
      2: 'No need for WiFi, train when and where convenient',
      3: 'Sales tools & resources at your fingertips',
    },
    continue: 'Continue anyway',
  },
  points: {
    pointsToLevel: '{pointsToLevel} {points} until you have reached the {rank} ranking!',
    outOf: '{points} XP out of',
    pointsToRank: '{pointsToLevel}XP needed to rank:  ({rank})',
  },
  appSelector: {
    enter: 'Enter',
    copy: {
      664: 'River Cruising',
      661: 'Escorted Touring',
      665: 'Independent Travel Vacations',

      799: 'River Cruising',
      790: 'Escorted Touring',
      791: 'Independent Travel Vacations',

      795: 'River Cruising',
      793: 'Escorted Touring',
      798: 'Independent Travel Vacations',

      792: 'River Cruising',
      797: 'Escorted Touring',
    },
  },
};
